import {ExpenseDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_EXPENSE';

export async function createExpense(
    userData: Record<string, string>,
    expense: Record<string, any>
) {

    try {
        const result = await ExpenseDao.createExpense(userData.userToken, expense);

        return result;
    }

    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
